import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import Group from 'components/utils/Group'
import useListTruncator from 'hooks/useListTruncator'
import React, { MouseEventHandler, ReactElement, useCallback } from 'react'
import SearchTileStackAmenitiesList from 'components/SearchKit/SearchTiles/shared/SearchTileStackAmenitiesList'

interface Props {
  features: Array<App.OfferInclusion>
  featuresType: 'inclusions' | 'amenities'
  cancellationPolicy?: ReactElement | false
  onMoreClick?: () => void
  singleColumn?: boolean
}

const MAX_INCLUSIONS_TO_SHOW = 6

function ExperimentalSearchTileFeaturesList({
  features,
  featuresType,
  cancellationPolicy,
  onMoreClick,
  singleColumn,
}: Props) {
  const [visibleInclusions, hiddenInclusions] = useListTruncator(MAX_INCLUSIONS_TO_SHOW - Number(!!cancellationPolicy), features)
  const handleMoreClick = useCallback<MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onMoreClick?.()
  }, [onMoreClick])
  if (!cancellationPolicy && !visibleInclusions.length) return null

  return <Group direction="vertical" gap={4}>
    {cancellationPolicy}
    {featuresType === 'inclusions' && visibleInclusions.map(inclusion =>
      <OfferInclusionItem
        key={inclusion.id}
        inclusion={inclusion}
        lineClamp={2}
      />,
    )}
    {featuresType === 'inclusions' && !!hiddenInclusions.length && <div>
      {!!onMoreClick && <TextLink size="small" onClick={handleMoreClick}>+ <FormatDecimal value={hiddenInclusions.length} /> more</TextLink>}
      {!onMoreClick && <BodyText variant="small" weight="bold">+ <FormatDecimal value={hiddenInclusions.length} /> more</BodyText>}
    </div>}
    {featuresType === 'amenities' &&
      <SearchTileStackAmenitiesList
        amenities={features}
        singleColumn={singleColumn}
      />}
  </Group>
}

export default ExperimentalSearchTileFeaturesList
